/* global global, window */

export const NativeError = typeof window === 'undefined'
	  ? global.Error
	  : window.Error
;
